import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const PermissionsPopup = ({ permissionsData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const renderPermissionRow = (permissionType, permissionData) => (
        <tr key={permissionType}>
            <td>{permissionType}</td>
            {["create", "review", "approve", "issue"].map((action) => (
                <td key={action}>
                    {permissionData[action] !== undefined ? (
                        <div className="form-check custom-checkbox">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={permissionData[action]}
                                readOnly
                            />
                        </div>
                    ) : null}
                </td>
            ))}
            <td>
                <div className="form-check custom-checkbox">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={Object.values(permissionData).every((val) => val)}
                        readOnly
                    />
                </div>
            </td>
        </tr>
    );

    return (
        <>
            <button className="btn btn-outline-primary btn-sm" onClick={handleShow}>View All</button>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                size="lg" 
            >
                <Modal.Header closeButton>
                    <Modal.Title>Permissions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Permission</th>
                                <th>Create</th>
                                <th>Review</th>
                                <th>Approve</th>
                                <th>Issue</th>
                                <th>Select All</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(permissionsData).map(([type, data]) =>
                                renderPermissionRow(type, data)
                            )}
                        </tbody>
                    </table>
                </Modal.Body>

            </Modal>
        </>
    );
};

export default PermissionsPopup;
